import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b33e16da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "citation" }
const _hoisted_2 = {
  key: 0,
  class: "truncate-2",
  tabindex: "0"
}
const _hoisted_3 = {
  key: 1,
  class: "truncate-2",
  tabindex: "0"
}

import { computed } from "vue";

interface Props {
  /** work title */
  title?: string;
  /** list of authors */
  authors?: string;
  /** journal, issue, date, or other misc info */
  details?: Array<string>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCitation',
  props: {
    title: null,
    authors: null,
    details: null
  },
  setup(__props: any) {

const props = __props as {
  /** work title */
  title?: string;
  /** list of authors */
  authors?: string;
  /** journal, issue, date, or other misc info */
  details?: Array<string>;
}



/** joined details as string */
const detailsString = computed(() =>
  (props.details || []).filter((e) => e).join("&nbsp; · &nbsp;")
);

return (_ctx: any,_cache: any) => {
  const _component_AppMarkdown = _resolveComponent("AppMarkdown")!

  return (_openBlock(), _createElementBlock("blockquote", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    (__props.authors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.authors), 1))
      : _createCommentVNode("", true),
    (_unref(detailsString))
      ? (_openBlock(), _createBlock(_component_AppMarkdown, {
          key: 2,
          class: "truncate-2",
          tabindex: "0",
          source: _unref(detailsString)
        }, null, 8, ["source"]))
      : _createCommentVNode("", true)
  ]))
}
}

})